import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSuggestionsAiQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetSuggestionsAiQuery = { __typename?: 'Query', generateHints: Array<string> };

export type GetSuggestionsRegulationsQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetSuggestionsRegulationsQuery = { __typename?: 'Query', searchRegulations: { __typename?: 'FullTextRegulationResult', regulations: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string }> } };

export type GetSuggestionsRegulatoryDocumentQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetSuggestionsRegulatoryDocumentQuery = { __typename?: 'Query', searchRegulatoryDocuments: { __typename?: 'FullTextRegulatoryDocumentResult', regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', regulationNumber: string } | null }> } };

export type GetSuggestionsRequirementsQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetSuggestionsRequirementsQuery = { __typename?: 'Query', searchRequirements: { __typename?: 'FullTextRequirementResult', requirements: Array<{ __typename?: 'Requirement', id: string, requirementId?: string | null }> } };

export type GetSuggestionsPogisQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetSuggestionsPogisQuery = { __typename?: 'Query', searchPogisDocuments: { __typename?: 'FullTextPogisDocumentResult', pogisDocuments: Array<{ __typename?: 'PogisDocument', id: string, shortInfo: string, pogisId: string }> } };


export const GetSuggestionsAiDocument = gql`
    query GetSuggestionsAI($searchString: String!, $limit: Int) {
  generateHints(searchString: $searchString, limit: $limit)
}
    `;

/**
 * __useGetSuggestionsAiQuery__
 *
 * To run a query within a React component, call `useGetSuggestionsAiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestionsAiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestionsAiQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSuggestionsAiQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestionsAiQuery, GetSuggestionsAiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestionsAiQuery, GetSuggestionsAiQueryVariables>(GetSuggestionsAiDocument, options);
      }
export function useGetSuggestionsAiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestionsAiQuery, GetSuggestionsAiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestionsAiQuery, GetSuggestionsAiQueryVariables>(GetSuggestionsAiDocument, options);
        }
export type GetSuggestionsAiQueryHookResult = ReturnType<typeof useGetSuggestionsAiQuery>;
export type GetSuggestionsAiLazyQueryHookResult = ReturnType<typeof useGetSuggestionsAiLazyQuery>;
export type GetSuggestionsAiQueryResult = Apollo.QueryResult<GetSuggestionsAiQuery, GetSuggestionsAiQueryVariables>;
export const GetSuggestionsRegulationsDocument = gql`
    query GetSuggestionsRegulations($searchString: String!, $limit: Int) {
  searchRegulations(searchString: $searchString, limit: $limit) {
    regulations {
      id
      regulationNumber
    }
  }
}
    `;

/**
 * __useGetSuggestionsRegulationsQuery__
 *
 * To run a query within a React component, call `useGetSuggestionsRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestionsRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestionsRegulationsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSuggestionsRegulationsQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestionsRegulationsQuery, GetSuggestionsRegulationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestionsRegulationsQuery, GetSuggestionsRegulationsQueryVariables>(GetSuggestionsRegulationsDocument, options);
      }
export function useGetSuggestionsRegulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestionsRegulationsQuery, GetSuggestionsRegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestionsRegulationsQuery, GetSuggestionsRegulationsQueryVariables>(GetSuggestionsRegulationsDocument, options);
        }
export type GetSuggestionsRegulationsQueryHookResult = ReturnType<typeof useGetSuggestionsRegulationsQuery>;
export type GetSuggestionsRegulationsLazyQueryHookResult = ReturnType<typeof useGetSuggestionsRegulationsLazyQuery>;
export type GetSuggestionsRegulationsQueryResult = Apollo.QueryResult<GetSuggestionsRegulationsQuery, GetSuggestionsRegulationsQueryVariables>;
export const GetSuggestionsRegulatoryDocumentDocument = gql`
    query GetSuggestionsRegulatoryDocument($searchString: String!, $limit: Int) {
  searchRegulatoryDocuments(searchString: $searchString, limit: $limit) {
    regulatoryDocuments {
      id
      name
      regulation {
        regulationNumber
      }
    }
  }
}
    `;

/**
 * __useGetSuggestionsRegulatoryDocumentQuery__
 *
 * To run a query within a React component, call `useGetSuggestionsRegulatoryDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestionsRegulatoryDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestionsRegulatoryDocumentQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSuggestionsRegulatoryDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestionsRegulatoryDocumentQuery, GetSuggestionsRegulatoryDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestionsRegulatoryDocumentQuery, GetSuggestionsRegulatoryDocumentQueryVariables>(GetSuggestionsRegulatoryDocumentDocument, options);
      }
export function useGetSuggestionsRegulatoryDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestionsRegulatoryDocumentQuery, GetSuggestionsRegulatoryDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestionsRegulatoryDocumentQuery, GetSuggestionsRegulatoryDocumentQueryVariables>(GetSuggestionsRegulatoryDocumentDocument, options);
        }
export type GetSuggestionsRegulatoryDocumentQueryHookResult = ReturnType<typeof useGetSuggestionsRegulatoryDocumentQuery>;
export type GetSuggestionsRegulatoryDocumentLazyQueryHookResult = ReturnType<typeof useGetSuggestionsRegulatoryDocumentLazyQuery>;
export type GetSuggestionsRegulatoryDocumentQueryResult = Apollo.QueryResult<GetSuggestionsRegulatoryDocumentQuery, GetSuggestionsRegulatoryDocumentQueryVariables>;
export const GetSuggestionsRequirementsDocument = gql`
    query GetSuggestionsRequirements($searchString: String!, $limit: Int) {
  searchRequirements(searchString: $searchString, limit: $limit) {
    requirements {
      id
      requirementId
    }
  }
}
    `;

/**
 * __useGetSuggestionsRequirementsQuery__
 *
 * To run a query within a React component, call `useGetSuggestionsRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestionsRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestionsRequirementsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSuggestionsRequirementsQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestionsRequirementsQuery, GetSuggestionsRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestionsRequirementsQuery, GetSuggestionsRequirementsQueryVariables>(GetSuggestionsRequirementsDocument, options);
      }
export function useGetSuggestionsRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestionsRequirementsQuery, GetSuggestionsRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestionsRequirementsQuery, GetSuggestionsRequirementsQueryVariables>(GetSuggestionsRequirementsDocument, options);
        }
export type GetSuggestionsRequirementsQueryHookResult = ReturnType<typeof useGetSuggestionsRequirementsQuery>;
export type GetSuggestionsRequirementsLazyQueryHookResult = ReturnType<typeof useGetSuggestionsRequirementsLazyQuery>;
export type GetSuggestionsRequirementsQueryResult = Apollo.QueryResult<GetSuggestionsRequirementsQuery, GetSuggestionsRequirementsQueryVariables>;
export const GetSuggestionsPogisDocument = gql`
    query GetSuggestionsPogis($searchString: String!, $limit: Int) {
  searchPogisDocuments(searchString: $searchString, limit: $limit) {
    pogisDocuments {
      id
      shortInfo
      pogisId
    }
  }
}
    `;

/**
 * __useGetSuggestionsPogisQuery__
 *
 * To run a query within a React component, call `useGetSuggestionsPogisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestionsPogisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestionsPogisQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSuggestionsPogisQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestionsPogisQuery, GetSuggestionsPogisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestionsPogisQuery, GetSuggestionsPogisQueryVariables>(GetSuggestionsPogisDocument, options);
      }
export function useGetSuggestionsPogisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestionsPogisQuery, GetSuggestionsPogisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestionsPogisQuery, GetSuggestionsPogisQueryVariables>(GetSuggestionsPogisDocument, options);
        }
export type GetSuggestionsPogisQueryHookResult = ReturnType<typeof useGetSuggestionsPogisQuery>;
export type GetSuggestionsPogisLazyQueryHookResult = ReturnType<typeof useGetSuggestionsPogisLazyQuery>;
export type GetSuggestionsPogisQueryResult = Apollo.QueryResult<GetSuggestionsPogisQuery, GetSuggestionsPogisQueryVariables>;